module.exports = __webpack_public_path__ + "static/media/drumnow-thumbnail.245904c9.jpg";